import ResourceList from '../../../components/admin/ResourceList'

export default function ComponentsList({ enablePullToRefresh }) {
    return (
        <ResourceList
            enablePullToRefresh={enablePullToRefresh}
            itemClickPath={'/storybook/:item.title'}
            items={[
                {
                    title: 'Tag',
                },
                {
                    title: 'PremiumBanner',
                },
            ]}
            fields={[
                {
                    column: 1,
                    getValue: (item) => item.title,
                },
            ]}
        />
    )
}
